import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SurpriseGridComponent } from "./surprise-grid/surprise-grid.component";
import { SurprisePageComponent } from "./surprise-page/surprise-page.component";
import { RouterModule, Routes } from "@angular/router";

import { IconsModule } from "@va/core-library/icons";
import { FormsModule } from "@angular/forms";
import { ChartPlotterModule } from "../chart-plotter/chart-plotter.module";
import { SharedModule } from "../shared/shared.module";
import { RightPanelModule } from "../right-panel/right-panel.module";

// ant modules
import { NzTableModule } from "ng-zorro-antd/table";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzSwitchModule } from "ng-zorro-antd/switch";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzCollapseModule } from "ng-zorro-antd/collapse";

const surpriseRoutes: Routes = [
  {
    path: "",
    pathMatch: "full",
    component: SurprisePageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(surpriseRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class SurpriseRoutingModule {}

@NgModule({
  declarations: [SurpriseGridComponent, SurprisePageComponent],
  imports: [
    CommonModule,
    SurpriseRoutingModule,
    IconsModule,
    SharedModule,
    FormsModule,
    ChartPlotterModule,
    RightPanelModule,
    NzTableModule,
    NzLayoutModule,
    NzSwitchModule,
    NzModalModule,
    NzInputModule,
    NzSelectModule,
    NzPopoverModule,
    NzIconModule,
    NzToolTipModule,
    NzCollapseModule,
  ],
})
export class SurprisePageModule {}
